import { filterClasses } from "@swivl-mono/helpers";

import "./PageLayout.Styles.scss";

interface PageLayout_TwoCol_Props {
  col1: JSX.Element;
  col2: JSX.Element;
  col1NoPadding?: boolean;
  col2NoPadding?: boolean;
}
export function PageLayout_TwoCol_Narrow_Wide(props: PageLayout_TwoCol_Props) {
  return (
    <div className="PageLayout TwoCol_NarrowWide">
      <div className={`column col1 ${props.col1NoPadding ? "noPadding" : ""}`}>{props.col1}</div>
      <div className={`column col2 ${props.col2NoPadding ? "noPadding" : ""}`}>{props.col2}</div>
    </div>
  );
}

interface Layout_SidebarProps {
  sidebar: JSX.Element;
  content: JSX.Element;
  sidebarNoPadding?: boolean;
  contentNoPadding?: boolean;
  sidebarClassName?: string;
  className?: string;
}
export function LayoutWithSidebar(props: Layout_SidebarProps) {
  return (
    <div className={filterClasses("LayoutWithSidebar absolute inset-0", props.className)}>
      <div className="absolute top-0 bottom-0 left-0 z-0 w-60 overflow-auto border-r border-grey-400 bg-white">{props.sidebar}</div>
      <div className={`absolute top-0 right-0 bottom-0 left-60 z-50 overflow-y-auto`}>{props.content}</div>
    </div>
  );
}

export function LayoutWithWideSidebar(props: Layout_SidebarProps) {
  return (
    <div className="LayoutWithSidebar absolute inset-0">
      <div
        className={`absolute top-0 bottom-0 left-0 w-[300px] overflow-y-auto border-r border-grey-400 bg-white pt-0 ${props.sidebarClassName ?? ""}`}
      >
        {props.sidebar}
      </div>
      <div className={`absolute top-0 right-0 bottom-0 left-[300px] z-50 overflow-y-auto`}>{props.content}</div>
    </div>
  );
}

export function LayoutHeader(props: { children: JSX.Element | JSX.Element[]; noPadding?: boolean; className?: string }) {
  return (
    <div className={props.className ? "LayoutHeader " + props.className : "LayoutHeader"} style={props.noPadding ? { padding: "0" } : {}}>
      {props.children}
    </div>
  );
}
